import React, { useState } from 'react';
import axios from 'axios';
import './ReservationForm.css';
import API_CONFIG2 from '../API_CONFIG2/API_CONFIG2';
import { Link } from 'react-router-dom';

const ReservationForm = ({ vehicle, onClose, onSubmit, id, prix, marque }) => {
  const [formData, setFormData] = useState({
    id,
    nomComplet: '',
    email: '',
    adresse: '',
    telephone: '',
    numeroPieceIdentite: '',
    typePieceIdentite: 'carte_identite',
    dateDebut: '',
    dateFin: '',
    informationsComplementaires: ''
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [serverMessage, setServerMessage] = useState(''); // message de confirmation à afficher
  const [reservationCode, setReservationCode] = useState(null); // code renvoyé par le backend (si fourni)

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.nomComplet.trim()) newErrors.nomComplet = 'Le nom complet est requis';
    if (!formData.email.trim()) newErrors.email = 'L\'email est requis';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'L\'email n\'est pas valide';
    if (!formData.adresse.trim()) newErrors.adresse = 'L\'adresse est requise';
    if (!formData.telephone.trim()) newErrors.telephone = 'Le numéro de téléphone est requis';
    else if (!/^[+]?[0-9\s\-\(\)]{10,}$/.test(formData.telephone)) newErrors.telephone = 'Le numéro de téléphone est invalide';
    if (!formData.numeroPieceIdentite.trim()) newErrors.numeroPieceIdentite = 'Le numéro de pièce d\'identité est requis';
    if (!formData.dateDebut) newErrors.dateDebut = 'La date de début est requise';
    if (!formData.dateFin) newErrors.dateFin = 'La date de fin est requise';

    if (formData.dateDebut && formData.dateFin) {
      const debut = new Date(formData.dateDebut);
      const fin = new Date(formData.dateFin);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (debut < today) newErrors.dateDebut = 'La date de début ne peut pas être dans le passé';
      if (fin <= debut) newErrors.dateFin = 'La date de fin doit être après la date de début';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const calculateDuree = () => {
    if (formData.dateDebut && formData.dateFin) {
      const debut = new Date(formData.dateDebut);
      const fin = new Date(formData.dateFin);
      const diffTime = Math.abs(fin - debut);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }
    return 0;
  };

  const calculatePrixTotal = () => {
    const duree = calculateDuree();
    const prixJournalier = vehicle?.prix || prix || 0;
    return prixJournalier * duree;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    setErrors({});
    try {
      const duree = calculateDuree();
      const prixTotal = calculatePrixTotal();

      const reservationData = {
        ...formData,
        vehicleId: id,
        duree,
        prixTotal,
        prixJournalier: vehicle?.prix || prix || 0
      };

      // Envoi des données au backend
      const response = await axios.post(`${API_CONFIG2.apiUrl}reservation.php`, reservationData, {
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.data && response.data.success) {
        // Si backend renvoie un code, on le récupère
        const code = response.data.code ?? null;
        setReservationCode(code);

        // Message plus convivial
        const msg = code
          ? `Un e-mail vous a été envoyé contenant le code de réservation ${code}. Veuillez utiliser ce code pour effectuer votre paiement en ligne ou directement auprès de notre agence.`
          : `Un e-mail de confirmation vous a été envoyé. Veuillez vérifier votre boîte mail et utiliser le code fourni pour le paiement en ligne ou auprès de notre agence.`;

        setServerMessage(msg);
        setSubmitted(true);

        // callback parent
        if (onSubmit) onSubmit(reservationData);

        // auto-close du modal après 6s si onClose fourni (optionnel)
        if (onClose) {
          setTimeout(() => {
            try { onClose(); } catch(e){ /* ignore */ }
          }, 6000);
        }
      } else {
        // erreur fournie par le backend
        throw new Error(response.data.message || 'Erreur lors de la réservation');
      }
    } catch (error) {
      console.error('Erreur lors de la réservation:', error);
      setErrors({
        submit: error.response?.data?.message || error.message || 'Une erreur est survenue lors de l\'envoi de la réservation'
      });
    } finally {
      setLoading(false);
    }
  };

  const duree = calculateDuree();
  const prixTotal = calculatePrixTotal();

  return (
    <div className="reservation-form-black-metal">
      {submitted ? (
        <div className="reservation-success-message">
          <h2>✅ Réservation confirmée</h2>
          <p style={{ whiteSpace: 'pre-line' }}>
            {serverMessage ||
              "Un e-mail de confirmation vous a été envoyé contenant un code que vous devrez utiliser pour le paiement en ligne ou directement auprès de notre agence. si vous ne voyez pas le mail, verifier dans le spam"}
          </p>

          <div className="reservation-success-actions">
            <Link to={`/reservation-auto/${id}`}
              className="submit-button-metal"
             
            >
              RETOUR
            </Link>
          </div>
        </div>
      ) : (
        <>
          <div className="reservation-header-metal">
            <h2 className='text-white'>FORMULAIRE DE RÉSERVATION</h2>
            {vehicle && (
              <div className="vehicle-info-metal">
                <h3>{marque}</h3>
                <p>PRIX JOURNALIER: <strong>{(prix ?? prix ?? 0).toLocaleString()} $</strong></p>
              </div>
            )}
          </div>

          <form className="reservation-form-metal" onSubmit={handleSubmit} noValidate>
            {/* INFORMATIONS PERSONNELLES */}
            <div className="form-section-metal">
              <h3>INFORMATIONS PERSONNELLES</h3>
              <div className="form-row">
                <div className="form-group-metal full-width">
                  <label>NOM COMPLET *</label>
                  <input
                    type="text"
                    name="nomComplet"
                    value={formData.nomComplet}
                    onChange={handleChange}
                    className={errors.nomComplet ? 'error-metal' : ''}
                    placeholder="VOTRE NOM ET PRÉNOM"
                    required
                  />
                  {errors.nomComplet && <span className="error-message-metal">{errors.nomComplet}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group-metal">
                  <label>EMAIL *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className={errors.email ? 'error-metal' : ''}
                    placeholder="VOTRE@EMAIL.COM"
                    required
                  />
                  {errors.email && <span className="error-message-metal">{errors.email}</span>}
                </div>

                <div className="form-group-metal">
                  <label>TÉLÉPHONE *</label>
                  <input
                    type="tel"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleChange}
                    className={errors.telephone ? 'error-metal' : ''}
                    placeholder="+243 99 123 4567"
                    required
                  />
                  {errors.telephone && <span className="error-message-metal">{errors.telephone}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group-metal full-width">
                  <label>ADRESSE COMPLÈTE *</label>
                  <textarea
                    name="adresse"
                    value={formData.adresse}
                    onChange={handleChange}
                    className={errors.adresse ? 'error-metal' : ''}
                    placeholder="NUMÉRO, RUE, CODE POSTAL, VILLE, PAYS"
                    rows="3"
                    required
                  />
                  {errors.adresse && <span className="error-message-metal">{errors.adresse}</span>}
                </div>
              </div>
            </div>

            {/* PIÈCE D'IDENTITÉ */}
            <div className="form-section-metal">
              <h3>PIÈCE D'IDENTITÉ</h3>
              <div className="form-row">
                <div className="form-group-metal">
                  <label>TYPE DE PIÈCE *</label>
                  <select
                    name="typePieceIdentite"
                    value={formData.typePieceIdentite}
                    onChange={handleChange}
                    className="select-metal"
                    required
                  >
                    <option value="carte_identite">CARTE D'IDENTITÉ</option>
                    <option value="passeport">PASSEPORT</option>
                    <option value="permis_conduire">PERMIS DE CONDUIRE</option>
                  </select>
                </div>

                <div className="form-group-metal">
                  <label>NUMÉRO DE PIÈCE *</label>
                  <input
                    type="text"
                    name="numeroPieceIdentite"
                    value={formData.numeroPieceIdentite}
                    onChange={handleChange}
                    className={errors.numeroPieceIdentite ? 'error-metal' : ''}
                    placeholder="NUMÉRO DE LA PIÈCE D'IDENTITÉ"
                    required
                  />
                  {errors.numeroPieceIdentite && <span className="error-message-metal">{errors.numeroPieceIdentite}</span>}
                </div>
              </div>
            </div>

            {/* PÉRIODE DE LOCATION */}
            <div className="form-section-metal">
              <h3>PÉRIODE DE LOCATION</h3>
              <div className="form-row">
                <div className="form-group-metal">
                  <label>DATE DE DÉBUT *</label>
                  <input
                    type="date"
                    name="dateDebut"
                    value={formData.dateDebut}
                    onChange={handleChange}
                    className={errors.dateDebut ? 'error-metal' : ''}
                    min={new Date().toISOString().split('T')[0]}
                    required
                  />
                  {errors.dateDebut && <span className="error-message-metal">{errors.dateDebut}</span>}
                </div>

                <div className="form-group-metal">
                  <label>DATE DE FIN *</label>
                  <input
                    type="date"
                    name="dateFin"
                    value={formData.dateFin}
                    onChange={handleChange}
                    className={errors.dateFin ? 'error-metal' : ''}
                    min={formData.dateDebut || new Date().toISOString().split('T')[0]}
                    required
                  />
                  {errors.dateFin && <span className="error-message-metal">{errors.dateFin}</span>}
                </div>
              </div>

              {duree > 0 && (
                <div className="reservation-summary-metal">
                  <div className="summary-item-metal">
                    <span>DURÉE DE LOCATION:</span>
                    <strong>{duree} JOUR{duree > 1 ? 'S' : ''}</strong>
                  </div>
                  <div className="summary-item-metal">
                    <span>PRIX JOURNALIER:</span>
                    <strong>{(vehicle?.prix || prix || 0).toLocaleString()} $</strong>
                  </div>
                  <div className="summary-item-metal">
                    <span>PRIX TOTAL:</span>
                    <strong className="total-price-metal">{prixTotal.toLocaleString()} $</strong>
                  </div>
                </div>
              )}
            </div>

            {/* INFORMATIONS COMPLÉMENTAIRES */}
            <div className="form-section-metal">
              <h3>INFORMATIONS COMPLÉMENTAIRES</h3>
              <div className="form-group-metal full-width">
                <label>COMMENTAIRES OU DEMANDES SPÉCIALES</label>
                <textarea
                  name="informationsComplementaires"
                  value={formData.informationsComplementaires}
                  onChange={handleChange}
                  placeholder="LIEU DE PRISE EN CHARGE, OPTIONS SUPPLÉMENTAIRES, ETC."
                  rows="4"
                  className="textarea-metal"
                />
              </div>
            </div>

            {/* Erreur générale */}
            {errors.submit && (
              <div className="form-error-metal">{errors.submit}</div>
            )}

            {/* Actions */}
            <div className="form-actions-metal">
              {onClose && (
                <button type="button" onClick={onClose} disabled={loading} className="cancel-button-metal">
                  ANNULER
                </button>
              )}
              <button
                type="submit"
                disabled={loading}
                className={`submit-button-metal ${loading ? 'loading-metal' : ''}`}
              >
                {loading ? (
                  <>
                    <div className="spinner-metal" />
                    ENVOI EN COURS...
                  </>
                ) : (
                  'CONFIRMER LA RÉSERVATION'
                )}
              </button>
            </div>
          </form>
        </>
      )}
    </div>
  );
};

export default ReservationForm;
